import { _ as r } from "./export-cdcbfb2b.js";
import { s as t, c as a } from "./string-html-forced-a746405b.js";
var e = r, o = a, l = t;
e({ target: "String", proto: !0, forced: l("small") }, {
  small: function() {
    return o(this, "small", "", "");
  }
});
